

export function hasPermission(permissions, module, permission) {
  const moduleData = permissions?.find(mod => mod.module_name === "Sales Production")
    ?.children?.find(child => child.module_name === module);
  return moduleData ? moduleData[`can_${permission}`] ?? false : false;
}

// Specific permission functions
export const hasDeveloperPermission = (permissions, permission) => 
  hasPermission(permissions, "Developer", permission);

export const hasProjectPermission = (permissions, permission) => 
  hasPermission(permissions, "Projects/Properties", permission);

  //
export function hasServicesPermission(permissions, module, permission) {
  const moduleData = permissions?.find(mod => mod.module_name === "Services")
    ?.children?.find(child => child.module_name === module);
  return moduleData ? moduleData[`can_${permission}`] ?? false : false;
}
export const hasServicePermission = (permissions, permission) => 
  hasServicesPermission(permissions, "Documentations List", permission);

export const hasDocumentationPermission = (permissions, permission) => 
  hasServicesPermission(permissions, "Documentations List", permission);